export class NoteSubject {
    private _code: string = "";
    private _text: string = "";
    private _isSelected: boolean = false;

    constructor(code: string, text: string) {
        this._code = code;
        this._text = text;
    }

    get code() {
        return this._code;
    }

    get text() {
        return this._text;
    }

    get isSelected() {
        return this._isSelected;
    }

    select() {
        this._isSelected = true;
    }

    unselect() {
        this._isSelected = false;
    }

    toggle() {
        this._isSelected = !this._isSelected;
    }
}
